(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["premium-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('premium-popup')) return;

    customElements.define('premium-popup', class PremiumPopup extends HTMLElement {
      connectedCallback() {
        this._overlay = this.querySelector('.premium-popup-overlay');
        if (!this._overlay) return;

        this._delay      = parseInt(this.dataset.delay, 10);
        this._expiry     = parseInt(this.dataset.expiry, 10) || 7;
        this._alwaysShow = this.dataset.alwaysShow === 'true';
        // v2 key — forces fresh start, ignores old dismissals
        this._storageKey = 'pp_v2_dismissed_' + this.id;

        this._bindEvents();

        if (window.Shopify && Shopify.designMode) {
          // Show immediately in editor
          this._show();
          document.addEventListener('shopify:section:load',   (e) => { if (e.target.contains(this)) this._show(); });
          document.addEventListener('shopify:section:select', (e) => { if (e.target.contains(this)) this._show(); });
        } else {
          this._scheduleShow();
        }
      }

      disconnectedCallback() {
        clearTimeout(this._timer);
      }

      _scheduleShow() {
        // Singleton guard — only first popup on page fires
        if (window.__premiumPopupActive) return;
        window.__premiumPopupActive = true;

        // Skip dismissed check if always_show is on
        if (!this._alwaysShow) {
          const ts = localStorage.getItem(this._storageKey);
          if (ts) {
            const elapsed = Date.now() - parseInt(ts, 10);
            if (elapsed < this._expiry * 864e5) return;
          }
        }

        const delay = isNaN(this._delay) ? 3000 : this._delay;
        this._timer = setTimeout(() => this._show(), delay);
      }

      _bindEvents() {
        const closeBtn = this.querySelector('.premium-popup-close');
        if (closeBtn) closeBtn.addEventListener('click', () => this._hide());
        this._overlay.addEventListener('click', (e) => {
          if (e.target === this._overlay) this._hide();
        });
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this._overlay.classList.contains('is-open')) this._hide();
        });
      }

      _show() {
        if (!this._overlay) return;
        this._overlay.classList.add('is-open');
        // Trigger transition on next frame
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this._overlay.classList.add('is-visible');
          });
        });
        document.body.style.overflow = 'hidden';
      }

      _hide() {
        this._overlay.classList.remove('is-visible');
        setTimeout(() => {
          this._overlay.classList.remove('is-open');
          document.body.style.overflow = '';
        }, 450);

        if (!(window.Shopify && Shopify.designMode)) {
          localStorage.setItem(this._storageKey, Date.now().toString());
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
